module.exports = __webpack_public_path__ + "img/muban.a5e37f84.png";